import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { track } from "@/lib/track";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { AdvisorChat } from "@/components/site/AdvisorChat";
import Home from "@/pages/Home";
import Cabana from "@/pages/Cabana";
import Brangus from "@/pages/Brangus";
import Herramientas from "@/pages/Herramientas";
import Galeria from "@/pages/Galeria";
import Catalogo from "@/pages/Catalogo";
import Premios from "@/pages/Premios";
import Contacto from "@/pages/Contacto";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("visit", pathname);
  }, [pathname]);
  return (
    <>
      <Header />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <AdvisorChat />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/la-cabana" element={<Cabana />} />
            <Route path="/brangus" element={<Brangus />} />
            <Route path="/herramientas" element={<Herramientas />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/premios" element={<Premios />} />
            <Route path="/contacto" element={<Contacto />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </AppProvider>
  );
}
